/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_No_OfficialsInputs */



/**
* | output |
* | --- |
* | "No officials found" |
*
* @param {Community_No_OfficialsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_no_officials = /** @type {((inputs?: Community_No_OfficialsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_No_OfficialsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun officiel trouvé")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron oficiales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum oficial encontrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun ufficiale trovato")
	return /** @type {LocalizedString} */ ("No officials found")
});